import Vue from 'vue'

// eslint-disable-next-line no-unused-vars
export default function (router) {
  const agora = new Date()
  const dataLimite = new Date('2026-02-23T23:59:00')

  const mostrarAvisoTemporario = agora <= dataLimite

  const abrirModalEnterprise = () => {
    Vue.swal({
      title: '<div style="color:#ed7d3e;">🚀 Novo Plano Enterprise disponível!</div>',
      html: `
        <div style="color:rgb(25, 48, 81); font-size: 18px;">
          <br>
          Olá!
          <br>
          Lançamos um pacote especial com novas funcionalidades:
          <br>
          <b>DTE, MIT, Parcelamentos Mei e novas integrações municipais.</b> Cada módulo possui valor individual.
          <br><br>
          Entre em contato com nosso suporte para saber mais.<br><br> 
          Para clientes do Plano Exclusivo, o parcelamento MEI já está liberado e pode ser configurado diretamente no sistema.
          <br><br><br>
          <b>Atenciosamente, Equipe Monitor Contábil</b>
        </div>
      `,
      icon: 'warning',
      iconColor: '#ed7d3e',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      width: '35%',
      customClass: {
        popup: 'swal-m',
        confirmButton: 'btn btn-primary mt-2',
      },
    }).then(result => {
      if (result.isDenied) {
        router.push({ name: 'empresa-view', query: { filtroRapido: 'ApenasCPF' } })
      }
    })
  }

  if (mostrarAvisoTemporario) {
    Vue.swal({
      title: '<div style="color:#ed7d3e;">📢 Aviso Importante – Atendimento Temporário</div>',
      html: `
        <div style="color:rgb(25, 48, 81); font-size: 18px;">
          <br>
          Entre os dias <b>19 e 23</b>, nosso atendimento será realizado exclusivamente pelos seguintes canais:
          <br><br>
          📞 <b>(11) 97556-1240</b>
          <br><br>
          📧 beatriz@monitorcontabil.com.br
          <br>
          📧 rebeca.abreu@monitorcontabil.com.br
          <br>
          📧 ouvidoria@monitorcontabil.com.br
          <br><br>
          Para assuntos financeiros, entre em contato também pelos canais acima ou pelo e-mail:
          <br>
          📧 financeiro@monitorcontabil.com.br
          <br><br>
          ⏰ <b>Horário de atendimento:</b><br>
          Segunda a sexta-feira, das 08h30 às 18h.
          <br><br>
          Agradecemos a compreensão e permanecemos à disposição para auxiliá-lo(a).
        </div>
      `,
      icon: 'info',
      iconColor: '#ed7d3e',
      confirmButtonText: 'Entendi',
      buttonsStyling: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      width: '40%',
      customClass: {
        popup: 'swal-m',
        confirmButton: 'btn btn-primary mt-2',
      },
    }).then(() => {
      abrirModalEnterprise()
    })
  } else {
    abrirModalEnterprise()
  }
}
